import { useAtom } from 'jotai';
import { mainAtom, mainScope } from '@src/store/main';

export const useMainInfo = () => {
  return useAtom(mainAtom, mainScope);
};
